import React, { useEffect } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { EventType } from 'src/dtos/analytics.dto';
import { useStores } from '../../store';
import useCustomModal from 'src/components/shared/custom-modal/custom-modal';
interface ErrorBoundaryProps {
  children?: any;
}
export const ErrorBoundaryComponent: React.FC<ErrorBoundaryProps> = (props) => {
  const { userStore } = useStores();

  const ErrorFallback = ({ error }: FallbackProps) => {
    const [, showErrorModal, contextHolder] = useCustomModal();

    useEffect(() => {
      showErrorModal({});
    }, [error]);

    return contextHolder;
  };

  const logError = (error: Error, info: { componentStack: string }) => {
    userStore.sendGeneralEvent(EventType.UnknownError, { error: error.message || error, info: info.componentStack, logLevel: 'error' });
  };

  return <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError} >
    {props.children}
  </ErrorBoundary>;
};